import Quill from 'quill';
const Delta = Quill.import('delta');
export class ShiftEnterModule {
  quill;
  constructor(quill) {
    this.quill = quill;
    quill.keyboard.bindings[13].unshift({
      key: 13,
      shiftKey: true,
      handler: function (range) {
        quill.updateContents(new Delta().retain(range.index).delete(0).insert({
          shiftEnter: true
        }), 'user');
        if (!quill.getLeaf(range.index + 1)?.[0]?.next) {
          quill.updateContents(new Delta().retain(range.index + 1).delete(0).insert({
            shiftEnter: true
          }), 'user');
        }
        quill.setSelection(range.index + 1, Quill.sources.SILENT);
        return false; // Don't call other candidate handlers
      }
    });
  }
}